import AnimationController from '../../assets/js/controllers/animation';
import DetectController from '../../assets/js/controllers/detect';
import ResizeController from '../../assets/js/controllers/resize';
import ScrollController from '../../assets/js/controllers/scroll';

import { map, getRootOffset } from '../../assets/js/helpers';

export default class TwoWays {

	static selector = 'two-ways';

	el = {};
	bounds = {};

	min;
	max;

	previous = 0;
	current = 0;

	constructor(container) {
		this.el = {
			container,
			heading: container.querySelector(`.${this.constructor.selector}__heading`),
			headingInner: container.querySelector(`.${this.constructor.selector}__heading .${this.constructor.selector}__heading-desktop`),
		};

		this.isDesktop = DetectController.isDesktop;

		if (this.isDesktop) {
			this.measure();
			this.start();
			this.addEventListeners();
		}
	}

	addEventListeners() {
		ResizeController.add(this.#onWindowResize);
	}

	removeEventListeners() {
		ResizeController.remove(this.#onWindowResize);
	}

	#onWindowResize = () => {
		this.measure();
	}

	measure() {
		this.bounds = {
			headingTop: getRootOffset(this.el.heading).top,
			headingHeight: this.el.heading.clientHeight,
			winHeight: window.innerHeight
		};

		this.max = this.bounds.winHeight * 0.3;
		this.min = -1 * this.max;
	}

	calculateParallax() {
		const scroll = this.bounds.headingTop - this.bounds.winHeight - ScrollController.eased;
		const from = this.bounds.winHeight;
		const to = -1 * this.bounds.headingHeight;
		return map(scroll, from, to, this.min, this.max);
	}

	start() {
		this.animation = AnimationController.set({
			update: this.#update,
			render: this.#render
		});
	}

	stop() {
		AnimationController.clear(this.animation);
		this.animation = null;
	}

	#update = () => {
		if (ScrollController.eased >= this.bounds.headingTop - this.bounds.winHeight
			&& ScrollController.eased <= this.bounds.headingTop + this.bounds.winHeight) {
			this.current = this.calculateParallax();
			return true;
		}
	}

	#render = () => {
		this.el.headingInner.style.transform = `translate3d(0, -${this.current}px, 0)`;
	}

	destroy() {
		this.removeEventListeners();
		this.stop();
	}

}
